import { forwardRef, type ComponentProps } from "react";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";

type Props = Omit<ComponentProps<typeof Link>, "to"> & {
  to: string;
};

/**
 * React Router Link с префиксом `/ru` для русской версии.
 * Якоря (`#contacts`) и внешние URL не изменяются.
 */
export const LocalizedLink = forwardRef<HTMLAnchorElement, Props>(function LocalizedLink(
  { to, ...rest },
  ref,
) {
  const lp = useLocalizedPath();

  if (to.startsWith("#") || to.startsWith("http://") || to.startsWith("https://") || to.startsWith("mailto:")) {
    return <Link ref={ref} to={to} {...rest} />;
  }

  const base = to.includes("#") ? to.slice(0, to.indexOf("#")) : to;
  const hash = to.includes("#") ? to.slice(to.indexOf("#")) : "";
  const localized = lp(base || "/");

  return <Link ref={ref} to={`${localized}${hash}`} {...rest} />;
});
